import { Spinner } from 'react-bootstrap';

import styles from './Loading.module.css';
import fesaudeLogo from '../../assets/img/fesaude-logo.png';

const Loading = () => {
  return (
    <div className={styles.spinnerContainer}>
      <Spinner animation="border" variant="primary" className={styles.spinner} />

      <div className={styles.loading}>
        <span>Carregando...</span>

        <img src={fesaudeLogo} alt="Logo FeSaúde" className={styles.logo} />
      </div>
    </div>
  );
};

export default Loading;
